var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.row.type)+" - "+_vm._s(_vm.$trans(_vm.row.name))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }